module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#e6f0f2"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "background-color": "#e6f0f2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入企业名称",
      "size": "large"
    },
    model: {
      value: (_vm.unitName),
      callback: function($$v) {
        _vm.unitName = $$v
      },
      expression: "unitName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("企业名称:")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#08c",
      "font-weight": "bold"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.loadData()
      }
    },
    slot: "append"
  }, [_vm._v("查询/Search")])], 2)], 1), _vm._v(" "), (!_vm.seachShow) ? _c('div', {
    staticStyle: {
      "width": "85%",
      "margin": "0 auto",
      "border": "1px dashed #000",
      "margin-top": "40px",
      "min-width": "730px",
      "background-color": "#e6f0f2"
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "background-color": "#e6f0f2"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.headerStyle,
      "height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "unitName",
      "label": "单位名称",
      "width": "280"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "establishmentTime",
      "label": "成立时间",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "注册地址",
      "width": "450"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "capital",
      "label": "注册资本（万元）",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shareholder",
      "label": "股东名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ratio",
      "label": "持股比例",
      "width": "100"
    }
  })], 1), _vm._v(" "), _vm._m(2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seachShow),
      expression: "seachShow"
    }],
    staticStyle: {
      "widht": "20px",
      "height": "1800px",
      "background-color": "#e6f0f2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.ceprei.com/assets/img/logo1-default.png",
      "alt": "Logo"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#dcdcdc",
      "padding-top": "3px",
      "padding-bottom": "1px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#e6f0f2"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "250%",
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("\n         所办企业信息查询\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "15px",
      "color": "#97a8be"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/"
    }
  }, [_vm._v("首页")]), _vm._v(" / 所办企业信息查询\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('p', {
    staticStyle: {}
  }, [_vm._v("如有疑问或发现假冒五所（赛宝）名称、商标的情况，请咨询 38390984，gaojing@ceprei.com ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#e6f0f2"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://guangzhou.cyberpolice.cn/netalarm/netalarm/Welcome.jsp?bano=4401060100873",
      "data-v-4d3159fe": "",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/cyberpolice.bfb5ba4.gif",
      "border": "0",
      "data-v-4d3159fe": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  粤ICP备09030372号\n      ")]), _vm._v(" "), _c('p', [_vm._v("网站维护：020-87237193 业务联系：020-87236881")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6564135c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/consignation/enterprise.vue
// module id = 1209
// module chunks = 10